// Источник визита (UTM-метки, yclid Директа, ClientID Метрики) для сквозной аналитики:
// сохраняем при заходе на сайт и отправляем при регистрации нового номера.
const ATTRIBUTION_STORAGE_KEY = "uprasti_ad_attribution";
const ATTRIBUTION_MAX_AGE_DAYS = 90;
const ATTRIBUTION_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "yclid",
];

function canUseWindow() {
  return typeof window !== "undefined";
}

function sanitizeValue(value) {
  return String(value || "").trim().slice(0, 200);
}

function readStoredAttribution() {
  if (!canUseWindow()) return null;

  try {
    const stored = JSON.parse(
      window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY) || "null"
    );
    if (!stored || typeof stored !== "object") return null;

    const maxAgeMs = ATTRIBUTION_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
    if (stored.capturedAt && Date.now() - stored.capturedAt > maxAgeMs) {
      return null;
    }

    return stored;
  } catch (_) {
    return null;
  }
}

function writeStoredAttribution(attribution) {
  if (!canUseWindow()) return;

  try {
    window.localStorage.setItem(
      ATTRIBUTION_STORAGE_KEY,
      JSON.stringify(attribution)
    );
  } catch (_) {}
}

// Query первого захода: приложение уводит незалогиненного посетителя с «/?utm…» на «/login»
// без параметров, а лендингу нужна группа объявления (utm_content) для выбора сценария.
// После редиректа на «/login» обновление страницы теряет и параметры, и память модуля,
// поэтому query с выбором сценария дублируем в sessionStorage (живёт до закрытия вкладки).
let entrySearch = null;
const ENTRY_SEARCH_KEY = "uprasti_entry_search";
const ENTRY_SEARCH_PARAMS = ["g", "s", "utm_content"];

function rememberEntrySearch(search) {
  const params = new URLSearchParams(search || "");
  if (!ENTRY_SEARCH_PARAMS.some((key) => params.get(key))) return;
  try {
    window.sessionStorage.setItem(ENTRY_SEARCH_KEY, String(search).slice(0, 500));
  } catch (_) {}
}

function readRememberedEntrySearch() {
  try {
    return window.sessionStorage.getItem(ENTRY_SEARCH_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function getEntrySearch() {
  if (!canUseWindow()) return "";
  const current = entrySearch !== null ? entrySearch : window.location.search || "";
  return current || readRememberedEntrySearch();
}

// Последний рекламный переход перезаписывает предыдущий, первый — сохраняется отдельно.
export function captureAttributionFromLocation(search = "") {
  if (!canUseWindow()) return null;
  if (entrySearch === null) {
    entrySearch = search || window.location.search || "";
    rememberEntrySearch(entrySearch);
  }

  const params = new URLSearchParams(search || window.location.search || "");
  const touch = {};

  ATTRIBUTION_PARAMS.forEach((key) => {
    const value = sanitizeValue(params.get(key));
    if (value) touch[key] = value;
  });

  if (!Object.keys(touch).length) return readStoredAttribution();

  const stored = readStoredAttribution() || {};
  const now = Date.now();
  const nextTouch = {
    ...touch,
    landing: sanitizeValue(window.location.pathname + window.location.hash),
    referrer: sanitizeValue(document.referrer),
    at: now,
  };

  const attribution = {
    ...stored,
    first: stored.first || nextTouch,
    last: nextTouch,
    capturedAt: now,
  };

  writeStoredAttribution(attribution);
  return attribution;
}

export function saveMetrikaClientId(clientId) {
  const safeId = sanitizeValue(clientId);
  if (!safeId) return;

  const stored = readStoredAttribution() || { capturedAt: Date.now() };
  if (stored.ymClientId === safeId) return;

  writeStoredAttribution({ ...stored, ymClientId: safeId });
}

export function appendAttributionToPayload(payload = {}) {
  const attribution = readStoredAttribution();

  if (!attribution) return payload;

  return {
    ...payload,
    attribution: {
      first: attribution.first,
      last: attribution.last,
      ymClientId: attribution.ymClientId,
    },
  };
}
